import { render, staticRenderFns } from "./dataSourceMgr.vue?vue&type=template&id=6cc4c23e&scoped=true"
import script from "./dataSourceMgr.vue?vue&type=script&lang=js"
export * from "./dataSourceMgr.vue?vue&type=script&lang=js"
import style0 from "./dataSourceMgr.vue?vue&type=style&index=0&id=6cc4c23e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4c23e",
  null
  
)

export default component.exports